import Button from '@Components/Buttons/Button'
import React, { useState } from 'react'
import { IPIValidator } from '@App/helpers/validate'
import clsx from 'clsx'

interface UpdateWriterIPIFormProps {
    onBack(): void
    onSubmit(newIpiNumber: string): void
    currentIpiNumber: string | undefined
}

const UpdateWriterIPIForm = ({ onBack, onSubmit, currentIpiNumber }: UpdateWriterIPIFormProps) => {
    const [newIpiNumber, setNewIpiNumber] = useState<string>()
    const [isIpiValid, setIsIpiValid] = useState<boolean>(true)
    const [isReviewing, setIsReviewing] = useState<boolean>(false)
    const isUpdating = !!currentIpiNumber

    const onIpIChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newIpi = e.target.value
        setIsIpiValid(IPIValidator(newIpi, true))
        setNewIpiNumber(newIpi)
    }

    return (
        <>
            <h2>Request to {isUpdating ? <>Update</> : <>Add</>} Writer IPI</h2>
            <p>
                It's important to make sure your writer IPI (Interested Party Information) is correct and up to date to
                ensure your songs are associated properly.
            </p>
            <div>
                <p>Current IPI Number:</p>
                <span>
                    <b>{currentIpiNumber ?? <>None</>}</b>
                </span>
            </div>
            <div>
                {isReviewing ? (
                    <>
                        <p>Suggested IPI Number:</p>
                        <b>{newIpiNumber}</b>
                    </>
                ) : (
                    <>
                        <p>What is the {isUpdating && 'correct '}IPI Number?</p>
                        <textarea
                            className={clsx(!isIpiValid && 'invalid-ipi')}
                            rows={1}
                            id="ipi-update"
                            onChange={onIpIChange}
                        />
                        {!isIpiValid && (
                            <p className="error-text">
                                The writer IPI you entered is invalid. The system requires that there be between 9-11
                                digits in the Writer IPI. Try removing or adding zeros to the beginning of the number.
                                If you’re still having trouble, contact Member Support.
                            </p>
                        )}
                    </>
                )}
            </div>
            <div className="footer-buttons">
                <Button mainColor type="secondary" onClick={isReviewing ? () => setIsReviewing(false) : onBack}>
                    Back
                </Button>

                {isReviewing ? (
                    <Button mainColor type="primary" onClick={() => newIpiNumber && onSubmit(newIpiNumber)}>
                        Submit Request
                    </Button>
                ) : (
                    <Button
                        mainColor
                        type="primary"
                        disabled={!isIpiValid || !newIpiNumber}
                        onClick={() => setIsReviewing(true)}
                    >
                        Review
                    </Button>
                )}
            </div>
        </>
    )
}

export default UpdateWriterIPIForm
